/**
 * RS-21 — read the X-Soft-Limit-Warning response header from rule
 * mutations. Returns the warning code (e.g. 'rules-exceed-10') or
 * null when no warning is present.
 *
 * Backend emits the header from ShippingRuleController::store when the
 * merchant exceeds 10 rules (PRD §6.1, §14). Creation still succeeds —
 * the merchant just sees a non-blocking toast.
 *
 * HTTP headers are case-insensitive per RFC 7230, so accept any casing.
 * Some axios versions surface multi-value headers as arrays; flatten.
 */
type Headers = Record<string, string | string[] | undefined> | null | undefined;

export function detectSoftLimitWarning(headers: Headers): string | null {
  if (!headers) return null;

  // Case-insensitive lookup.
  const target = 'x-soft-limit-warning';
  const entry = Object.entries(headers).find(
    ([key]) => key.toLowerCase() === target,
  );
  if (!entry) return null;

  const [, value] = entry;
  const flat = Array.isArray(value) ? value[0] : value;
  if (!flat) return null;

  return flat;
}
